import {useEffect} from 'react'
import {Ga4Data, ga4} from 'utils/ga4'

export const useGa4MountEffect = (data: Ga4Data) => {
  return useEffect(() => {
    ga4(data)
  }, [data])
}
